<template>
  <div>
    <el-radio-group v-model="zone" size="mini" @change="onZone">
      <el-radio-button border label="ANDRIOD">安卓</el-radio-button>
      <el-radio-button border label="IOS">IOS</el-radio-button>
    </el-radio-group>
    <el-radio-group v-model="server" @change="onServer" size="mini" style="margin-left: 10px;">
      <el-radio-button border label="QQ">QQ</el-radio-button>
      <el-radio-button border label="WECHAT">微信</el-radio-button>
    </el-radio-group>
  </div>
</template>

<script>
export default {
  name: 'mobileServer',
  components: {},
  props: ['serverList','baseZone','baseServer'],
  data() {
    return {
      server:'',
      zone:''
    }
  },
  watch: {
    baseZone(newValue, oldValue){
      console.log(newValue)
      this.zone=newValue
    },
    baseServer(newValue, oldValue){
      console.log(newValue)
      this.server=newValue
    }
  },
  computed: {},
  methods: {
    onZone() {
      this.$emit('onZone', this.zone)
    },
    onServer() {
      this.$emit('onServer', this.server)
    },
    setZone(val){
      this.zone=val
    },
    setServer(val){
      console.log(this.server)
      this.server=val
    }
  },
  created() { },
  mounted() {
    this.zone=this.baseZone
    this.server=this.baseServer
   }
};
</script>
<style lang="scss" scoped>
</style>